import { useClinician } from "src/context/SessionProvider/ClinicianProvider";

export const useIsAdmin = () => {
  const isAdmin = useClinician((clinician) =>
    clinician.roles.some((role) => role.name.includes("Admin")),
  );

  return isAdmin;
};
